import React from 'react';
import './Blogs.css';
import { FaTwitter, FaGithub, FaFileAlt } from 'react-icons/fa';

const blogs = [
  {
    title: "DeFi Research & Analysis Writeups",
    platform: "Research Archive",
    icon: <FaFileAlt />,
    link: "https://bit.ly/shivom-writeups",
    description: "Comprehensive research papers and analysis on DeFi protocols, tokenomics, and blockchain infrastructure.",
  },
  {
    title: "Twitter / X - Blockchain Insights",
    platform: "Twitter",
    icon: <FaTwitter />,
    link: "https://x.com/sheeki03",
    description: "Real-time thoughts on crypto markets, DeFi innovations, and blockchain technology trends.",
  },
  {
    title: "GitHub - Open Source Contributions",
    platform: "GitHub",
    icon: <FaGithub />,
    link: "https://github.com/sheeki03",
    description: "Smart contract implementations, DeFi research tools, and blockchain development projects.",
  },
];

const Blogs: React.FC = () => {
  return (
    <section className="blogs-container" aria-labelledby="blogs-heading">
      <header className="blogs-header">
        <h1 className="blogs-title" id="blogs-heading">📚 Research &amp; Writings</h1>
        <p className="blogs-intro">
          Deep dives into DeFi protocols, tokenomics, and blockchain research.
        </p>
      </header>

      {blogs.length === 0 ? (
        <div className="blogs-empty" role="status">
          <h2 className="blogs-empty-title">Nothing published yet</h2>
          <p className="blogs-empty-copy">
            New writeups land here first. Until then, read the code and research
            notes directly on GitHub.
          </p>
          <a
            className="blogs-empty-cta"
            href="https://github.com/sheeki03"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Browse open-source work on GitHub (opens in a new tab)"
          >
            Browse open-source work
          </a>
        </div>
      ) : (
        <ul className="blogs-grid" aria-busy="false">
          {blogs.map((blog, index) => {
            const featured = index === 0;
            return (
              <li
                key={blog.title}
                className={featured ? 'blog-card blog-card--featured' : 'blog-card'}
                style={{ '--delay': `${Math.min(index, 5) * 70}ms` } as React.CSSProperties}
              >
                <a
                  className="blog-link"
                  href={blog.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${blog.title} (${blog.platform}, opens in a new tab)`}
                >
                  <div className="blog-icon" aria-hidden="true">{blog.icon}</div>
                  <div className="blog-info">
                    <h2 className="blog-title">{blog.title}</h2>
                    <p className="blog-description">{blog.description}</p>
                    <span className="blog-platform">{blog.platform}</span>
                  </div>
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default Blogs;
